/**
 * Extracts `File` objects from a `DataTransfer` payload, preferring
 * `DataTransferItemList` (the modern API) and falling back to `files`.
 * Non-file items (e.g. dragged text selections) are filtered out.
 */
export const filesFromDataTransfer = (dataTransfer?: DataTransfer | null): File[] => {
  if (!dataTransfer) return [];

  const files: File[] = [];

  if (dataTransfer.items && dataTransfer.items.length > 0) {
    for (let i = 0; i < dataTransfer.items.length; i++) {
      const item = dataTransfer.items[i];
      if (item.kind === 'file') {
        const f = item.getAsFile();
        if (f) files.push(f);
      }
    }
    return files;
  }

  if (dataTransfer.files && dataTransfer.files.length > 0) {
    for (let i = 0; i < dataTransfer.files.length; i++) {
      files.push(dataTransfer.files[i]);
    }
  }

  return files;
};
